import {Inject, Injectable} from '@angular/core';
import {EntityService} from "@shared/services/entity.service";
import {EntityFeatureNameEnum} from "@shared/contracts/entity-store.contract";
import {PaymentTypeEnum, PaymentTypeType} from "@generated/graphql";
import {PaymentType} from "@modules/payment/models/payment-type.model";
import {PAYMENT_TYPE_STORE, PaymentTypeStore} from "@modules/payment/store/payment-type.store";
import {Store} from "@ngrx/store";
import {paymentTypeFactory, PaymentTypeFactory} from "@modules/payment/factories/payment-type.factory";
import {map, Observable} from "rxjs";
import {PaymentTypeApi} from "@modules/payment/api/payment-type.api";

@Injectable({
  providedIn: 'root'
})
export class PaymentTypeService extends EntityService<EntityFeatureNameEnum.PaymentType, PaymentTypeType, PaymentType> {
  findByName$(name: PaymentTypeEnum): Observable<PaymentType> {
    return this.entities$.pipe(
      map(items => items.find(item => item.name === name)),
      // map(item => item ? this.factory.create(item) : null)
    )
  }

  constructor(
    protected readonly store: Store,
    @Inject(PAYMENT_TYPE_STORE) protected readonly paymentTypeStore: PaymentTypeStore,
    protected readonly api: PaymentTypeApi
  ) {
    super(store, paymentTypeStore)
  }

  get factory(): PaymentTypeFactory {
    return paymentTypeFactory;
  }
}
